module.exports = __webpack_public_path__ + "img/us_未标题-5.c3ecebc1.jpg";